/* eslint-disable eag/match-named-export */
import {omneticApi} from '@dms/api/base';

import {
  CreateMagicPublishingApiArg,
  CreateMagicPublishingApiRes,
  GetMagicPublishingRequestApiArg,
  GetMagicPublishingRequestApiRes,
  ValidateMagicPublishingApiArg,
  ValidateMagicPublishingApiRes,
} from './types';

export const magicPublishingApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    validateMagicPublishing: build.mutation<
      ValidateMagicPublishingApiRes,
      ValidateMagicPublishingApiArg
    >({
      query: (queryArg) => ({
        url: '/dms/v1/magic-publishing/validate',
        method: 'POST',
        body: queryArg,
      }),
    }),
    createMagicPublishing: build.mutation<CreateMagicPublishingApiRes, CreateMagicPublishingApiArg>(
      {
        query: (queryArg) => ({
          url: '/dms/v1/magic-publishing/request',
          method: 'PUT',
          body: queryArg,
        }),
      }
    ),
    getMagicPublishingRequest: build.query<
      GetMagicPublishingRequestApiRes,
      GetMagicPublishingRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/magic-publishing/request/${queryArg.requestId}`,
      }),
    }),
  }),
});

export const {
  useValidateMagicPublishingMutation,
  useCreateMagicPublishingMutation,
  useGetMagicPublishingRequestQuery,
  useLazyGetMagicPublishingRequestQuery,
} = magicPublishingApi;
